import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as acessos from '../../../../../acessos.const.util';
import { atributosMedicoDetalhes } from '../../detalhes.utils';
import { acessoPermitido } from '../../../../../acessos.seguranca';
import {
  statusEtapasEnum,
  etapasIndexEnum,
  tipoMedicoEnum
} from '@common/util/defaultValues';

import ModalEditarMedico from '../ModalEditar';

function BtnEditarResponsavel ({
  medicos,
  medicoSelecionado,
  etapa,
  getStatusEtapa,
  className
}) {
  const usuario = useSelector(state => state.usuario);
  const editor = useSelector(state => state.editor);
  const detalhes = useSelector(state => state.commonReducer.detalhes);
  const [modal, setModal] = useState(false);
  const [medicoSelecionadoModal, setMedicoSelecionadoModal] = useState({});

  useEffect(() => {
    setMedicoSelecionadoModal(medicoSelecionado);
  }, [medicoSelecionado]);

  const toggle = () => setModal(!modal);

  const getDataConclusaoEtapa = () => {
    const atributos = atributosMedicoDetalhes.find(a => a.id === etapa.tab);
    return detalhes[atributos.data];
  };

  return (
    <div className={className}>
      {acessoPermitido(usuario, acessos.MedicoDesignado) && (
        <ModalEditarMedico
          toggle={toggle}
          setMedicoSelecionadoModal={setMedicoSelecionadoModal}
          medicoSelecionadoModal={medicoSelecionadoModal}
          tipoMedico={tipoMedicoEnum.MEDICO}
          modal={modal}
          etapa={etapa}
          medicos={medicos}
        />
      )}

      {acessoPermitido(usuario, acessos.MedicoDesignado) &&
        acessoPermitido(usuario, acessos.AlterarMedicoExecutanteRevisor) &&
        (getDataConclusaoEtapa() === '' ||
          etapa.tab === etapasIndexEnum.MATERIAL ||
          etapa.tab === etapasIndexEnum.NOTAS ||
          etapa.tab === etapasIndexEnum.ERRATA ||
          ([
            statusEtapasEnum.NAO_REALIZADO,
            statusEtapasEnum.PENDENTE,
            statusEtapasEnum.REVISAO
          ].indexOf(getStatusEtapa()) > -1 &&
            !editor.medExecutante)) && (
          <i
            className='mv-basico-atualizar'
            style={{
              padding: '0 5px',
              fontSize: '17px'
            }}
            onClick={toggle}
            data-toggle='tooltip'
            title='Alterar médico designado para o exame'
          ></i>
        )}
    </div>
  );
}

export default BtnEditarResponsavel;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/Medico/BtnEditarResponsavel/index.js